export default "/public/app-main/static/image/a2d82da9dc1156d78acdfdc47687d8ee.png";